export default __webpack_public_path__ + "static/klavesnica-26859a1e8e5d95ff9a449b5152bdb72b.jpg";